@if (isFlyoutOpen) {
  <app-switcher-flyout
    [flyoutTop]="flyoutTop"
    [flyoutLeft]="flyoutLeft"
    [ariaLabel]="'switcher' | translate"
    (closed)="closeFlyout()"
  ></app-switcher-flyout>
}

<ds-switcher-button
  data-test-id="switcher-button"
  [class.icon-only-button]="isCollapsed"
  [isIconOnly]="isCollapsed"
  [icon]="contextIcon()"
  [smallLabel]="contextType() | translate"
  [biggerLabel]="contextLabel()"
  [maxCharacters]="16"
  (clicked)="openSwitcherModal()"
></ds-switcher-button>
